<template>
  <div class="code-snippet">
    <pre ref="codeContainer">
      <code>
        function vmf_my_custom_class( $attributes ) {
          if ( is_single() ) {
              $attributes['class'] = $attributes['class'] . ' my-custom-class';
            }
            return $attributes;
        }
        add_filter( '{{ selectedFilter }}', 'vmf_my_custom_class' );
      </code>
    </pre>
  </div>

  <div class="filter-table">
    <table>
      <thead>
      <tr>
        <th style="text-align: left; width: 50%;">Context/HTML</th>
        <th style="text-align: left; width: 50%;">Genesis Filter</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, index) in filterRows"
          :key="index"
          :class="{ selected: selectedFilter === row.filter }"
          @click="updateSelectedFilter(row.filter); $nextTick(() => reinitializeHighlighting() )">
        <td>{{ row.context }}</td>
        <td>{{ row.filter }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import hljs from 'highlight.js';
export default {
  data() {
    return {
      selectedFilter: 'genesis_attr_body',
      filterRows: [
        {context: 'body', filter: 'genesis_attr_body'},
        {context: 'site-header', filter: 'genesis_attr_site-header'},
        {context: 'site-title', filter: 'genesis_attr_site-title'},
        {context: 'title-area', filter: 'genesis_attr_title-area'},
        {context: 'site-description', filter: 'genesis_attr_site-description'},
        {context: 'header-widget-area', filter: 'genesis_attr_header-widget-area'},
        {context: 'nav-primary', filter: 'genesis_attr_nav-primary'},
        {context: 'nav-secondary', filter: 'genesis_attr_nav-secondary'},
        {context: 'nav-header', filter: 'genesis_attr_nav-header'},
        {context: 'structural-wrap', filter: 'genesis_attr_structural-wrap'},
        {context: 'content', filter: 'genesis_attr_content'},
        {context: 'content-sidebar-wrap', filter: 'genesis_attr_content-sidebar-wrap'},
        {context: 'entry', filter: 'genesis_attr_entry'},
        {context: 'entry-image', filter: 'genesis_attr_entry-image'},
        {context: 'entry-image-widget', filter: 'genesis_attr_entry-image-widget'},
        {context: 'entry-image-grid-loop', filter: 'genesis_attr_entry-image-grid-loop'},
        {context: 'entry-author', filter: 'genesis_attr_entry-author'},
        {context: 'entry-author-link', filter: 'genesis_attr_entry-author-link'},
        {context: 'entry-author-name', filter: 'genesis_attr_entry-author-name'},
        {context: 'entry-time', filter: 'genesis_attr_entry-time'},
        {context: 'entry-modified-time', filter: 'genesis_attr_entry-modified-time'},
        {context: 'entry-title', filter: 'genesis_attr_entry-title'},
        {context: 'entry-content', filter: 'genesis_attr_entry-content'},
        {context: 'entry-meta-before-content', filter: 'genesis_attr_entry-meta-before-content'},
        {context: 'entry-meta-after-content', filter: 'genesis_attr_entry-meta-after-content'},
        {context: 'archive-pagination', filter: 'genesis_attr_archive-pagination'},
        {context: 'entry-pagination', filter: 'genesis_attr_entry-pagination'},
        {context: 'adjacent-entry-pagination', filter: 'genesis_attr_adjacent-entry-pagination'},
        {context: 'comments-pagination', filter: 'genesis_attr_comments-pagination'},
        {context: 'entry-comments', filter: 'genesis_attr_entry-comments'},
        {context: 'comment', filter: 'genesis_attr_comment'},
        {context: 'comment-author', filter: 'genesis_attr_comment-author'},
        {context: 'comment-author-link', filter: 'genesis_attr_comment-author-link'},
        {context: 'comment-time', filter: 'genesis_attr_comment-time'},
        {context: 'comment-time-link', filter: 'genesis_attr_comment-time-link'},
        {context: 'comment-content', filter: 'genesis_attr_comment-content'},
        {context: 'author-box', filter: 'genesis_attr_author-box'},
        {context: 'sidebar_primary', filter: 'genesis_attr_sidebar-primary'},
        {context: 'sidebar-secondary', filter: 'genesis_attr_sidebar-secondary'},
        {context: 'site-footer', filter: 'genesis_attr_site-footer'}
      ]
    }
  },
  methods: {
    updateSelectedFilter(filter) {

      this.selectedFilter = filter;
    },
    reinitializeHighlighting() {
      // Select all code blocks
      const codeBlocks = this.$refs.codeContainer.querySelectorAll('pre code');


      // Reinitialize highlighting
      codeBlocks.forEach((block) => {
        block.className = ''; // Clear all classes
        block.innerHTML = block.textContent; // Reset inner HTML
        block.dataset.highlighted = '';

        hljs.highlightElement(block);
      });
    },
  }
}
</script>

<style scoped>
.filter-table {
  margin: 1rem 0;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 0.5rem;
  border: 1px solid #ddd;
}

tbody tr {
  cursor: pointer;
}

tbody tr:hover {
  background-color: #f5f5f5;
}

.selected {
  background-color: #e3f2fd;
}

.code-snippet {
  background-color: #f5f5f5;
  padding: 1rem;
  border-radius: 4px;
}

pre {
  margin: 0;
}

code {
  font-family: monospace;
}
</style>